import "./PictureModal.scss"
import css from "styles/export.module.scss"

import React, { FunctionComponent, useState, useEffect, useMemo } from "react"

import iconClose from "assets/img/icon-close-white.svg"
import Spinner from "components/Spinner/Spinner"
import { getZIndex } from "utils/modal"

export interface IPictureModalProps {
    pictureSrc: string,
    onClose?(): Promise<void> | void
}

const PictureModal: FunctionComponent<React.PropsWithChildren<IPictureModalProps>> = ({
    pictureSrc,
    onClose
}) => {
    const [modalClass, setModalClass] = useState("")
    const [isBusy, setIsBusy] = useState(true)
    const zIndex = useMemo(() => getZIndex(), [])

    useEffect(() => {
        setModalClass("picture-modal--show")
        const img = new Image()
        img.onload = () => {
            setIsBusy(false)
        }
        img.src = pictureSrc
    }, [pictureSrc])

    const handleClose = () => {
        if (typeof onClose !== "function") return
        setModalClass("")

        // wait for css animation finish
        setTimeout(() => {
            onClose()
        }, +css.modalTransitionMs)
    }

    return (
        <div className={`picture-modal ${modalClass}`}
            role="dialog"
            aria-modal="true"
            style={{ zIndex }}>
            <div className="picture-modal__overlay"
                onClick={() => handleClose()}
                data-testid="picture-modal-overlay" />
            {!!onClose &&
                <button
                    type="button"
                    className="picture-modal__close"
                    onClick={() => onClose()}
                    aria-label="Close">
                    <img src={iconClose} alt="" aria-hidden />
                </button>
            }
            <div className="picture-modal__img-wrapper">
                <img src={pictureSrc} className="picture-modal__img" data-testid="picture-modal-img" alt="" />
                {isBusy && <Spinner />}
            </div>
        </div>
    )
}

export default PictureModal
